<svg [class]="'ui-icon-svg ' + size()">
  <use
    [attr.xlink:href]="'assets/generated-icons/icons.svg#' + iconName()"
    [attr.href]="'assets/generated-icons/icons.svg#' + iconName()"
  />
</svg>
